export enum RouteCMRAgents {
    driver = "driver",
    consignee = "consignee",
    sender = "sender",
    police = "police"
}
export class RouteCMRAgentsEnum {
    public static ID(agent: RouteCMRAgents) {
        return agent.toString().toUpperCase();
    }
    public static CAPTION(agent: RouteCMRAgents) {
        return "ROUTECMRAGENTS.ENUM." + agent.toString().toUpperCase();
    }
    public static HELP(agent: RouteCMRAgents) {
        return "ROUTECMRAGENTS.HELP." + agent.toString().toUpperCase();
    }

    public static isValid(agent: RouteCMRAgents){
        if(agent == null)
            return false;
        return true;
    }
}
